
$(function() {
    checkCustomInputs();

    $('.navbar-collapse a').on('click', function() {
        $('.navbar-toggle.active').trigger('click');
    });

    $('[data-background], img[data-src]').imageLoader();
//    $('.fade-effect').fadeEffect();

    setInterval(function() {
        $.get('/lib/keepalive.php');
    }, 1000 * 60 * 10);

    // Open popup links inside a modal
	$(document).on('click', 'a.popup', function(e) {
		e.preventDefault();
		window.top.openIframePopup($(this).attr('href'));
	});

	// Make sure internal links inside popups are opened correctly
	$('body.popup .text a[href^="/"]').addClass('popup');

	// Make sure external links inside popups are opened in a new window
	$('body.popup a[href^="http"]').attr('target', '_blank');

    $(document).on('click', '.confirm', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		var $popin    = $('.confirm-popin');
		var textYes   = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
		var textNo    = $(this).data('text-no')  || $popin.find('.no').data('text-no');
		var onConfirm = $(this).data('onconfirm') || '';

		if ($popin.is(':visible')) {
			return;
		}

		$popin.find('.text').html($(this).data('confirm'));
		$popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
		$popin.find('.no').text(textNo);
		$popin.modal();

		if (onConfirm) {
			$popin.find('.yes').attr('onclick', onConfirm);
		}
	});

    $(document).on('click', '.show-alert', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		// console.log('show alert', $(this).data('alert'));
		showAlert($(this).data('alert'));
	});
});

$('.navbar-collapse').on('show.bs.collapse', function() { $('.navbar-toggle').addClass('active'); });
$('.navbar-collapse').on('hide.bs.collapse', function() { $('.navbar-toggle').removeClass('active'); });

var lastScrollTop = 0;
$(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();

    if (scrollTop > 0) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }

    if ($('.navbar-collapse').hasClass('in')) {
        return;
    }

    if (scrollTop <= lastScrollTop - 80 || scrollTop == 0) {
        $('.navbar-fixed-top').addClass('visible');
        lastScrollTop = scrollTop;

    } else if (scrollTop > lastScrollTop + 40) {
        $('.navbar-fixed-top').removeClass('visible');
        lastScrollTop = scrollTop;
    }
}).trigger('scroll');

$(window).on('mousewheel', function() {
    $(window).trigger('scroll');
});
